<template>
  <div>
    <AddQuestions />
  </div>
</template>
<script>
import AddQuestions from '../../../components/dadban/packages/AddQuestions.vue'
export default {
  name: 'dadban-question-packages',
  components: { AddQuestions },
}
</script>
